<div class="input-field">
    <label for="date">Estado</label>
    <p-dropdown [options]="states" optionLabel="name" optionValue="id"
        appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona un estado" 
        [(ngModel)]="case.caseStateId" (onChange)="onChangeCaseState()"
        d-form-field-error></p-dropdown>
</div>
<div *ngIf="error_message!=''" class="mt-2" >
    <p-messages severity="error" [closable]="false" >
        <ng-template pTemplate>
           <div [innerHTML]=error_message></div>
        </ng-template>
    </p-messages>
</div>
<div *ngIf="profitability_message!=''" class="mt-2" >
    <p-messages severity="warn" [closable]="false" >
        <ng-template pTemplate>
           <div [innerHTML]=profitability_message></div>
        </ng-template>
    </p-messages>
</div>
<div *ngIf="caseStateConfiguration!=null&&error_message==''&&profitability_message==''">
    <div *ngFor="let field of caseStateConfiguration.fields">
        <div class="mt-2 input-field" *ngIf="checkShowCondition(field)">
            <label [for]="field.name">{{field.label}}</label>
            <p-dropdown *ngIf="field.type=='select'" [options]="field.options" optionLabel="label" optionValue="value"
                appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona una opción"
                [(ngModel)]="caseStateMetadata[field.code]" [ngModelOptions]="{standalone: true}" [required]="field.required"
                d-form-field-error></p-dropdown>
            <p-dropdown *ngIf="field.type=='select-capability'" [options]="capabilities" optionLabel="name" optionValue="id"
                appendTo="body" [filter]="true" filterBy="name" placeholder="Selecciona una opción"
                [(ngModel)]="case.pendingCapabilityId" [ngModelOptions]="{standalone: true}" [required]="field.required"
                d-form-field-error></p-dropdown>
            <p-inputSwitch *ngIf="field.type=='switch'" [(ngModel)]="caseStateMetadata[field.code]" [ngModelOptions]="{standalone: true}" [required]="field.required" d-form-field-error></p-inputSwitch>
            <input pInputText *ngIf="field.type=='text'" [(ngModel)]="caseStateMetadata[field.code]" [ngModelOptions]="{standalone: true}" [required]="field.required" d-form-field-error />
            <textarea pInputTextarea *ngIf="field.type=='textarea'" rows="4" maxlength="400" [(ngModel)]="caseStateMetadata[field.code]" [ngModelOptions]="{standalone: true}" [required]="field.required" d-form-field-error></textarea>
            <p-calendar *ngIf="field.type=='date'" [(ngModel)]="caseStateMetadata[field.code]" [ngModelOptions]="{standalone: true}" [required]="field.required" appendTo="body" d-form-field-error />
        </div>
    </div>
</div>
<div *ngIf="showReopenCheck">
    <div class="mt-2 input-field">
        <label>¿Es una reapertura?</label>
        <p-inputSwitch [(ngModel)]="caseStateMetadata['isReopen']" [ngModelOptions]="{standalone: true}" d-form-field-error></p-inputSwitch>
    </div>
</div>
<div class="flex mt-4">        
    <button pButton label="Cancelar" icon="pi pi-times" class="p-button-secondary" (click)="cancel()"></button>
    <div class="flex-grow-1"></div>
    <button pButton label="Guardar" icon="pi pi-check" (click)="save()" *ngIf="error_message==''"></button>
</div>